import { isTemplatePlaceholder } from '@/types';
import { CommsPreferencesFilter } from '@/types/searchFilterTypes';
import { COMMS_PREFERENCE_OPTIONS } from '@/constants/filterCriteria/commsPreferences';
import { FilterMapper } from './filterMapperTypes';
import { AutocompleteGenericEntity } from '@australiangreens/ag-internal-components';

export const CommsPreferencesMapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoPreferenceSelected = value[0].value.length === 0;
    return isNoPreferenceSelected;
  },

  toFilter({ value }): CommsPreferencesFilter {
    if (!value) throw new Error('Missing value');
    if (value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const nestedValue = value[0].value as AutocompleteGenericEntity[];

    let mappedValue;

    // The quick search has a dedicated commspreferencesinclusion boolean, but
    // this is not user selectable in the advanced search (since user can just
    // wrap in a negation group) so it just always gets set to true
    if (isTemplatePlaceholder(nestedValue)) {
      mappedValue = {
        commsPreferencesLabels: nestedValue,
        commsPreferencesInclusion: true,
      };
    } else {
      mappedValue = {
        commsPreferencesLabels: nestedValue.map(({ label }) => label),
        commsPreferencesInclusion: true,
      };
    }

    return {
      name: 'commsPreferences',
      value: mappedValue,
    };
  },

  async fromFilter(filter: CommsPreferencesFilter) {
    const { commsPreferencesLabels } = filter.value;

    if (isTemplatePlaceholder(commsPreferencesLabels)) {
      return {
        field: filter.name,
        operator: 'any in',
        value: [
          {
            value: commsPreferencesLabels,
            errors: [],
          },
        ],
      };
    }

    const commsPreferences = COMMS_PREFERENCE_OPTIONS.filter((x) =>
      commsPreferencesLabels.includes(x.label)
    );

    return {
      field: filter.name,
      operator: 'any in',
      value: [
        {
          value: commsPreferences,
          errors: [],
        },
      ],
    };
  },
};
